import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

function detectLanguage() {
  // Check localStorage first (user's explicit choice)
  const stored = localStorage.getItem('solt_language');
  if (stored === 'hu' || stored === 'en') return stored;
  // Fall back to browser language
  const lang = navigator.language || navigator.userLanguage || 'en';
  return lang.toLowerCase().startsWith('hu') ? 'hu' : 'en';
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(detectLanguage);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  function switchLanguage(lang) {
    setLanguage(lang);
    localStorage.setItem('solt_language', lang);
    document.documentElement.lang = lang;
  }

  return (
    <LanguageContext.Provider value={{ language, switchLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
